<template>
    <div  class="card-scroller overflow-x-hidden"
         >
        <div class="container w-full">
            <div class="inner flex flex-nowrap gap-2 align-stretch items-stretch data-te-lightbox-init" ref="holder" :style="carouselSideScrollerStyles">
                <slot></slot>
            </div>
        </div>
    </div>
    <div class="container mt-4 flex justify-end">
        <button :disabled='currentItem === 0'
                class='mx-1 flex items-center justify-center p-0 text-center carousel-side-scroller-button'
                @click='navigatePrev'><img :src="arrowIcon" style="width: 2.225rem" alt="previous"></button>
        <button :disabled='currentItem === (items.length - itemsFitWidth)'
                class='mx-1 flex rotate-180 items-center justify-center p-0 carousel-side-scroller-button'
                @click='navigateNext'><img :src="arrowIcon" style="width: 2.225rem" alt="next" class=""></button>
    </div>
</template>

<script>

import {Lightbox, initTE} from "tw-elements";
import gql from 'graphql-tag';

export default {
    name: "CardCarousel",
    props: {
        cardWidth: {
            type: Number,
            default: 300
        },
        numberOfItems: {
            type: Number,
            default: 0
        },
        arrowIcon: {
            type: String,
            default: ''
        },
    },
    data: {
        items: [],
        trueCardWidth: 0,
        pageWidth: 0,
        carouselWidth: 0,
        currentItem: 0,
        scrollBlockWidth: 0,
        cardGap: 8
    },
    computed: {
        offset: function () {
            return this.currentItem * this.scrollBlockWidth;
        },
        carouselSideScrollerStyles: function () {
            return 'margin-left: -' + this.offset + 'px; ';
        },
        itemsFitWidth: function () {
            return Math.floor(this.carouselWidth / this.scrollBlockWidth);
        },
    },
    watch: {},
    components: {},
    created: function () {
        // this.items = this.$slots.default();

    },
    destroyed: function () {
        window.removeEventListener("resize", this.setWidths);
    },
    mounted: function () {
        var width = this.$slots["default"][0];
        this.items = this.$refs.holder.children;
        window.addEventListener("resize", this.setWidths);
        this.setWidths();
        initTE({Lightbox});
    },
    methods: {
        setWidths: function () {
            this.trueCardWidth = (this.items[0]) ? this.items[0].clientWidth : 0;
            this.pageWidth = window.innerWidth;
            this.scrollBlockWidth = parseInt(this.trueCardWidth) + parseInt(this.cardGap);
            this.carouselWidth = (document.getElementsByClassName('spacer')[0]) ? document.getElementsByClassName('spacer')[0].offsetWidth : 0;
        },
        navigateNext: function () {
            ++this.currentItem;
            this.offsetSideScroller();
        },
        navigatePrev: function () {
            --this.currentItem;
            this.offsetSideScroller();
        },
        offsetSideScroller: function () {

        },
        carouselSideScrollerStyles: function () {

        }
    },
    render: h => h(App),
}
</script>

<style scoped>
    ::-webkit-scrollbar {
        width: 0px;
        background: transparent; /* make scrollbar transparent */
    }

    .inner {
        transition: margin-left 0.5s ease-in-out;
    }

</style>
